module.exports = __webpack_public_path__ + "static/img/success-toast.1e878c2a.svg";